import { Truck } from '@phosphor-icons/react';
import { useSettings } from '@/context/SettingsContext';
import { formatINR } from '@/lib/api';

export default function PromoStrip() {
  const { settings } = useSettings();
  if (settings.banner_enabled === false) return null;
  const threshold = settings.free_delivery_above || 299;
  const customText = (settings.banner_text || '').trim();
  return (
    <div className="bg-olive-800 text-cream-100 text-xs sm:text-sm" data-testid="promo-strip">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-2 text-center">
        <Truck size={16} weight="duotone" className="text-terracotta-300 shrink-0" />
        <span className="tracking-wide">
          {customText ? customText : (
            <>Free delivery on orders above <span className="font-semibold text-terracotta-300">{formatINR(threshold)}</span> · Cash on Delivery available</>
          )}
        </span>
      </div>
    </div>
  );
}
